<template>
    <div class="row">
      <login-banner></login-banner>

      <div class="col-md-6 login-wrap-bg">
        <!-- Login -->
        <div class="login-wrapper">
          <div class="loginbox">
            <div class="img-logo">
              <img src="@/assets/img/caduceus.png" class="img-fluid" alt="Logo" />
              <div class="back-home">
                <router-link to="/home/">Voltar para Home</router-link>
              </div>
            </div>
            <h1>Esqueceu o Password ?</h1>
            <div class="reset-password">
              <p>Informe seu email.</p>
            </div>
            <Form @submit="onSubmit" :validation-schema="schema" v-slot="{ errors }">
              <div class="input-block">
                <label class="form-control-label">Email</label>
                <Field
                  name="email"
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': errors.email }"
                />
              </div>
              <div class="d-grid">
                <button class="btn btn-start" type="submit" @click="resetarSenha()">Resetar</button>
              </div>
            </Form>
          </div>
        </div>
        <!-- /Login -->
      </div>
    </div>
</template>
<script>
import { Form, Field } from "vee-validate";
import * as Yup from "yup";
import { router } from "@/router";
import ApiService from "@/services/ApiService";
import Swal from "sweetalert2";
export default {
  data() {
    return {
      emailError: "",
    };
  },
  components: {
    Form,
    Field,
  },
  methods: {
    submitForm() {
      this.$router.push("/");
    },
    resetarSenha() {

    },
    async onSubmit(values) {
      this.emailError = "";
      await ApiService.post('/auth/generate-password', {email: values.email});
      Swal.fire("", `Um email foi enviado para ${values.email} com a nova senha`, "success");
      router.push('/login');
    },
  },
  setup() {
    const schema = Yup.object().shape({
      email: Yup.string().required("Email is required").email("Email is invalid"),
    });
    return {
      schema,
    };
  },
};
</script>
